import axios from "axios";
import api, { API } from "./api";

const mapi = axios.create({ baseURL: API });
mapi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nl_member_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const TYPE_META = {
  sweepstakes: { label: "Sweepstakes", verb: "Enter to win" },
  photo: { label: "Photo Contest", verb: "Upload & vote" },
  ballot: { label: "Best Of Ballot", verb: "Vote now" },
  quiz: { label: "Quiz", verb: "Play now" },
};

export const getCampaigns = (type) => mapi.get("/contests", { params: type ? { type } : {} }).then((r) => r.data);
export const getCampaign = (id) => mapi.get(`/contests/${id}`).then((r) => r.data);
export const enterCampaign = (id, d) => mapi.post(`/contests/${id}/enter`, d).then((r) => r.data);
export const submitContestPhoto = (id, d) => mapi.post(`/contests/${id}/photos`, d).then((r) => r.data);
export const voteContestPhoto = (id, pid, email) => mapi.post(`/contests/${id}/photos/${pid}/vote`, { email }).then((r) => r.data);

export const adminPromotions = () => api.get("/admin/promotions").then((r) => r.data);
export const adminPromotion = (id) => api.get(`/admin/promotions/${id}`).then((r) => r.data);
export const adminCreatePromotion = (d) => api.post("/admin/promotions", d).then((r) => r.data);
export const adminUpdatePromotion = (id, d) => api.put(`/admin/promotions/${id}`, d).then((r) => r.data);
export const adminDeletePromotion = (id) => api.delete(`/admin/promotions/${id}`).then((r) => r.data);
export const adminPromotionEntries = (id) => api.get(`/admin/promotions/${id}/entries`).then((r) => r.data);
export const adminPromotionResults = (id) => api.get(`/admin/promotions/${id}/results`).then((r) => r.data);
export const adminApprovePromoPhoto = (id, pid) => api.post(`/admin/promotions/${id}/photos/${pid}/approve`).then((r) => r.data);
export const adminDeletePromoPhoto = (id, pid) => api.delete(`/admin/promotions/${id}/photos/${pid}`).then((r) => r.data);
export const adminDrawWinner = (id) => api.post(`/admin/promotions/${id}/draw-winner`).then((r) => r.data);
export const adminAudience = () => api.get("/admin/audience").then((r) => r.data);
export const adminDownloadLeads = async (id, title) => {
  const r = await api.get(`/admin/promotions/${id}/leads.csv`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = `${title.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}-leads.csv`; a.click();
  URL.revokeObjectURL(url);
};
